import { motion } from "framer-motion";
import { useParams, Link } from 'react-router-dom'
import SerrviceList from './../../data/services.json';
import CloseIcon from './../../assets/images/icon/close.png';

const pageVariants = {
  initial: { scale: 0.9, opacity: 0 },
  in: { scale: 1, opacity: 1 },
  out: { scale: 0.9, opacity: 0 }
};

const pageTransition = {
  type: "tween",
  ease: "easeInOut",
  duration: 0.5,
};

const Services = () => {
  const params = useParams();
  const { slug } = params;
  console.warn(slug)
  const data = SerrviceList.find(item => item.slug === slug);
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Link to="/#services" className="mt-0" style={{ background: '#f7f8fc' }}>
        <img className="close-img" src={CloseIcon} alt="Close" />
      </Link>
      <section className="service">
        <div className="container">
          <div className="section-title" style={{ marginBottom: "50px" }}>
            <h1>{data.title}</h1>
            {/* <p>{data.tagline}</p> */}
          </div>
          <div className="row">
            <div className="col-lg-5 col-md-5">
              <p align="justify">{data.description}</p>
              {data.price1 === '' ?(
                <></>
              ):(
                <h3>Price : {data.price1}</h3>
              )}
              
              <Link className="btn btn-primary btn-sm scroll-to" to="/#enquiry">Enquire Now</Link>
            </div>
            <div className="col-lg-7 col-md-7 sub-services d-flex align-items-center justify-content-center">
              {data.image === '' ? (
                <ul>
                  <li><i className="fa fa-hand-o-right" aria-hidden="true" />Save time & reduce overheads</li>
                  <li><i className="fa fa-hand-o-right" aria-hidden="true" />Scale up or down easily</li>
                  <li><i className="fa fa-hand-o-right" aria-hidden="true" />Improve team productivity</li>
                  <li><i className="fa fa-hand-o-right" aria-hidden="true" />Impress clients with professional space</li>
                  <li><i className="fa fa-hand-o-right" aria-hidden="true" />Plug-and-play setup</li>
                  <li><i className="fa fa-hand-o-right" aria-hidden="true" />No maintenance worries</li>
                  <li><i className="fa fa-hand-o-right" aria-hidden="true" />Nearby landmarks, parking, metro/train stations</li>
                </ul>
              ) : (
                <img className="service-image" src={data.image} alt={data.title} />
              )}
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
};
export default Services;